export default __webpack_public_path__ + "static/media/manchor_preloader.b1dea053.svg";